import { css, SerializedStyles } from "@emotion/react";
import styled from "@emotion/styled";
import { EmotionTheme } from "src/domains/layouts/config/emotionTheme";
import { DefaultComponentVariantType } from "src/domains/layouts/config/features/types";
import { withConfig } from "src/withConfig";

interface EventMarketsWrapperPropsType {
    variant: DefaultComponentVariantType | null;
}

const setEventMarketsWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            display: flex;
            flex-flow: column nowrap;
            gap: ${theme.star.gap.medium};
        `;
    }
    return css``;
};

export const EventMarketsWrapper = withConfig(theme => styled('div', { label: 'EventMarketsWrapper' })<EventMarketsWrapperPropsType>`
    ${({ variant }): SerializedStyles => setEventMarketsWrapper(variant, theme)}
`);
